export default __webpack_public_path__ + "static/media/cheatday_cheesecrisps-wide@2x.892212f7.jpg";